import React, { useContext } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { CardContent } from '@components/layout/Card'

import useFeatureConfig, { FeatureNames } from '@hooks/useFeatureConfig'
import { Button } from '@components/Button'
import { NotesContext } from '../../context'
import { Note } from './Note'

const baseClass = "scenario-notes"

export const Index = () => {
  const [
    { isEnabled: createNoteEnabled },
    { isEnabled: editNoteEnabled },
    { isEnabled: viewPrivateNotesEnabled }
  ] = useFeatureConfig(
    FeatureNames.NOTE__CREATE,
    FeatureNames.NOTE__EDIT,
    FeatureNames.NOTE__VIEW_PRIVATE
  )

  const { actions: { showPrivateNotesToggle, goToCreateNote, goToImportNotes }, state: { showPrivateNotes, crudActions } } = useContext(NotesContext)

  const handleTogglePrivate = () => !showPrivateNotes && showPrivateNotesToggle()
  const handleTogglePublic = () => showPrivateNotes && showPrivateNotesToggle()

  return (
    <CardContent>
      <Tabs
        className='app-tabs'
        selectedIndex={showPrivateNotes ? 0 : 1}
        onSelect={() => { }}
      >
        <div className={`${baseClass}__tabs-container`}>
          <TabList className='app-tabs__list flex'>
            {viewPrivateNotesEnabled() &&
              <>
                <Tab
                  onClick={() => handleTogglePrivate()}
                  className='app-tabs__list-item'
                  selectedClassName='app-tabs__list-item--selected'>Private notes</Tab>
                <Tab
                  onClick={() => handleTogglePublic()}
                  className='app-tabs__list-item'
                  selectedClassName='app-tabs__list-item--selected'>Shared notes</Tab>
              </>
            }
          </TabList>
          {createNoteEnabled() && crudActions?.import &&
            <Button
              style={{
                marginLeft: 'auto'
              }}
              secondary
              trackAs='Import scenario notes'
              onClick={goToImportNotes}
            >
              Import notes
            </Button>
          }
          {createNoteEnabled() &&
            <Button
              style={{
                marginLeft: crudActions?.import ? '0.5rem' : 'auto'
              }}
              primary
              trackAs='New scenario note'
              onClick={goToCreateNote}
            >
              New note
            </Button>
          }
        </div>
        <TabPanel>
          <div className={`${baseClass}__notes-overflow-container`}>
            <NotesList showPrivate={true} editable={editNoteEnabled()} />
          </div>
        </TabPanel>
        <TabPanel>
          <div className={`${baseClass}__notes-overflow-container`}>
            <NotesList showPrivate={false} editable={editNoteEnabled()} />
          </div>
        </TabPanel>
      </Tabs>
    </CardContent>
  )
}

const NotesList = ({ showPrivate, editable }) => {
  const { state: { notes } } = useContext(NotesContext)

  const [privateNotes, publicNotes] = notes
    .map((note, index) => ({ ...note, index }))
    .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
    .reduce(([priv, pub], note) => note.visibility == 0 ? [priv, [...pub, note]] : [[...priv, note], pub], [[], []]);

  const showNotes = showPrivate ? privateNotes : publicNotes

  if (showNotes.length == 0) {
    return <EmptyNotesMessage showPrivate={showPrivate} />
  }

  return showNotes.map(
    ({ index, ...note }, idx) =>
      <Note key={`note-${index}-${idx}`} index={index} note={note} editable={editable} />
  )
}

const EmptyNotesMessage = ({ showPrivate }) =>
  <div className={`${baseClass}__empty-notes-message`}>
    <h2>Looks like there aren't any {showPrivate ? "private" : "shared"} notes yet.</h2>
  </div>
